import { render, staticRenderFns } from "./CHead.vue?vue&type=template&id=24836bd4&"
import script from "./CHead.vue?vue&type=script&lang=js&"
export * from "./CHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports